import intl from 'react-intl-universal';

export const DateFormatter = ({ value }: { value: string }) => {
  return value ? intl.get('common.date', { date: new Date(value) }) : '';
};

export const DateTimeFormatter = ({ value }: { value: string }) => {
  const locale = intl.getInitOptions().currentLocale;

  return value
    ? `${new Date(value).toLocaleDateString(locale, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
      })}`
    : '';
};
